module.exports = __webpack_public_path__ + "static/media/proj4.00e95b89.jpg";